import { useMemo, useSyncExternalStore } from 'react';
// this uses the same breakpoints as tailwind: https://v3.tailwindcss.com/docs/responsive-design
const getBreakpoint = (fallback) => {
    if (typeof window === 'undefined')
        return fallback;
    const w = window.innerWidth;
    if (w >= 1536)
        return '2xl';
    if (w >= 1280)
        return 'xl';
    if (w >= 1024)
        return 'lg';
    if (w >= 768)
        return 'md';
    if (w >= 640)
        return 'sm';
    return fallback;
};
const subscribe = (cb) => {
    window.addEventListener('resize', cb);
    return () => window.removeEventListener('resize', cb);
};
/**
 * Tracks the active Tailwind breakpoint from the window width.
 *
 * Flags are mobile-first: each `is*Screen` flag is true at its breakpoint and
 * every larger one. Server renders and widths below `sm` return
 * `defaultBreakpoint`.
 */
export const useBreakpoints = (defaultBreakpoint = 'sm') => {
    const activeBreakpoint = useSyncExternalStore(subscribe, () => getBreakpoint(defaultBreakpoint), () => defaultBreakpoint);
    // similar to tailwind, you start with mobile first and scale up. So "small" is true for both small and all larger breakpoints
    const isSmallScreen = true;
    const isMediumScreen = ['md', 'lg', 'xl', '2xl'].includes(activeBreakpoint);
    const isLargeScreen = ['lg', 'xl', '2xl'].includes(activeBreakpoint);
    const isXLargeScreen = ['xl', '2xl'].includes(activeBreakpoint);
    const is2XLargeScreen = ['2xl'].includes(activeBreakpoint);
    return useMemo(() => ({
        breakpoint: activeBreakpoint,
        isSmallScreen,
        isMediumScreen,
        isLargeScreen,
        isXLargeScreen,
        is2XLargeScreen,
    }), [
        activeBreakpoint,
        is2XLargeScreen,
        isLargeScreen,
        isMediumScreen,
        isSmallScreen,
        isXLargeScreen,
    ]);
};
//# sourceMappingURL=useBreakpoints.js.map